/**
 * Just a function that consumes a single argument, with no return.
 */
export type Consumer = (props: Record<string, unknown>) => void;
